






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import historyManager from "@/lib/historyManager";

@Component({ name: "GoBack" })
export default class GoBack extends Vue {
  @Prop({ default: null })
  public readonly defaultRoute!: Location | null;

  public onClick() {
    if (this.$listeners.click) {
      this.$emit("click");
    } else if (!historyManager.hasHistory() && this.defaultRoute) {
      this.$router.push(this.defaultRoute);
    } else {
      this.$router.back();
    }
  }
}
